<template>
    <div
        class="px-6 pb-5 cursor-pointer border-t border-gray-200"
        :class="{
            'bg-blue-50 hover:bg-gray-50 ': active,
            'hover:bg-gray-50 ': ! active,
            'pt-2.5':metadataSubtitle,
            'pt-5':!metadataSubtitle,
        }"
        tabindex="0"
        v-on="$listeners"
    >
        <div class="flex items-end">
            <span class="flex-1" :class="metadataSubtitle?'mt-2.5':''">
                <h2 v-if="titleAsHtml" v-html="titleAsHtml"
                    :class="titleClass + (truncateTitle?' truncate':'')"></h2>
                <h2 v-else v-text="title"
                    :class="titleClass + (truncateTitle?' truncate':'')"></h2>
                <p v-if="(metadata instanceof Array) && subtitle" v-text="subtitleAsLine"
                   class="mt-1 text-sm text-gray-500 truncate"></p>
            </span>
            <span class="text-right">
                <p v-for="line in (metadata instanceof Array?metadata:[metadata])"
                   class="ml-2 text-xs text-gray-500 truncate">{{ line }}</p>
                <p v-if="metadataSubtitle" v-text="metadataSubtitle"
                   class="ml-2 text-xs text-gray-900 truncate"></p>
           </span>
        </div>
        <div class="flex items-center">
            <p v-if="!(metadata instanceof Array) && subtitle" v-text="subtitleAsLine"
               class="mt-1 text-sm text-gray-500 truncate"></p>
            <div v-if="icon" class="text-gray-300 ml-auto" v-html="icon"></div>
        </div>
        <p v-if="subtext" class="mt-1 text-xs text-gray-500 truncate">{{ subtext }}</p>
        <slot></slot>
    </div>
</template>

<script>
import {toLine} from '@utils'

export default {
    props: {
        title: String,
        titleAsHtml: String,
        truncateTitle: Boolean,
        titleClass: String | 'text-sm font-medium text-gray-900',
        subtitle: String | Array,
        subtext: String,
        metadata: String | Array,
        metadataSubtitle: String | false,
        icon: String,
        active: Boolean,
        manual: Function,
    },
    computed: {
        subtitleAsLine() {
            return toLine(this.subtitle)
        }
    }
}
</script>
